import React from 'react';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { hot } from 'react-hot-loader';

export default hot(module)(function (props) {
	return (
		<Grid item sm={6} style={{ maxWidth: '50%' }} xs={12}>
			<Paper className="">
				<Typography component="h3" variant="h5">
					{props.children}
				</Typography>
			</Paper>
		</Grid>
	);
});
